import { useUserContext } from "#contexts/UserContextProvider"
import { RESOURCES, USER_ACTIONS } from "#customTypes/composedTypes/authTypes"
import { useGetOneUser } from "#hooks/newHooks/useGetUser"
import useHasPermission from "#hooks/newHooks/useHasPermission"

export const useHelpRequestCreator = (createdBy: string | undefined) => {
  return useGetOneUser(createdBy ?? null)
}

/** Returns true if the effective user can resolve a given help request (creator or FRONT_DESK+). */
export const useCanResolveHelpRequest = (
  requestCreatedBy: string | undefined
) => {
  const { effectiveUserId } = useUserContext()
  const hasDeletePermission = useHasPermission(
    RESOURCES.HELP_REQUEST,
    USER_ACTIONS.DELETE
  )

  const isCreator =
    !!effectiveUserId &&
    !!requestCreatedBy &&
    effectiveUserId === requestCreatedBy

  return isCreator || hasDeletePermission
}
